module.exports = __webpack_public_path__ + "media/images/bath-a4c18f8192efd43ec6e8cf316b6e6487.png";